import { useSelector } from 'react-redux';

import { offerSelector } from '../../../../../selectors';
import { WcLocationType } from '../../../../../store/offer';
import { IFeatureItem } from '../../../../../types/offerData';
import { getDealType, isRent } from '../../../../../utils/deal_type';
import { getOfferType, isResidential, isUrban } from '../../../../../utils/offer_type';

export const useFeaturesFlatRentProps = () => {
  const offer = useSelector(offerSelector);

  const dealType = getDealType(offer);
  const isRentOffer = isRent(dealType);

  const offerType = getOfferType(offer);
  const isResidentialOffer = isResidential(offerType);

  if (!isResidentialOffer || !isRentOffer) {
    return null;
  }

  const isUrbanOffer = isUrban(offerType);
  const title = isUrbanOffer ? 'В квартире есть' : 'В доме есть';

  const featuresList: IFeatureItem[] = [];

  if (offer.wcLocationType) {
    const text = offer.wcLocationType === WcLocationType.Indoors ? 'в доме' : 'на улице';

    featuresList.push({
      theme: 'toilet',
      name: `Санузел ${text}`,
    });
  }

  if (offer.hasFridge) {
    featuresList.push({
      theme: 'fridge',
      name: 'Холодильник',
    });
  }

  if (offer.hasDishwasher) {
    featuresList.push({
      theme: 'dishwasher',
      name: 'Посудомоечная машина',
    });
  }

  if (offer.hasWasher) {
    featuresList.push({
      theme: 'washing',
      name: 'Стиральная машина',
    });
  }

  if (offer.hasConditioner) {
    featuresList.push({
      theme: 'cond',
      name: 'Кондиционер',
    });
  }

  if (offer.hasTv) {
    featuresList.push({
      theme: 'tv',
      name: 'Телевизор',
    });
  }

  if (offer.hasInternet) {
    featuresList.push({
      theme: 'internet',
      name: 'Интернет',
    });
  }

  if (offer.hasBathtub) {
    featuresList.push({
      theme: 'bath',
      name: 'Ванна',
    });
  }

  if (offer.hasShower) {
    featuresList.push({
      theme: 'shower',
      name: 'Душевая кабина',
    });
  }

  if (offer.hasKitchenFurniture) {
    featuresList.push({
      theme: 'kitchen',
      name: 'Мебель на кухне',
    });
  }

  if (offer.hasFurniture) {
    featuresList.push({
      theme: 'furniture',
      name: 'Мебель в комнатах',
    });
  }

  if (!featuresList.length) {
    return null;
  }

  return {
    title,
    featuresList,
  };
};
